import { render, staticRenderFns } from "./ModalVerification.vue?vue&type=template&id=4b97a010&scoped=true"
import script from "./ModalVerification.vue?vue&type=script&lang=js"
export * from "./ModalVerification.vue?vue&type=script&lang=js"
import style0 from "./ModalVerification.vue?vue&type=style&index=0&id=4b97a010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97a010",
  null
  
)

export default component.exports